import { render, staticRenderFns } from "./NotificationLike.vue?vue&type=template&id=7d37f48e&scoped=true&"
import script from "./NotificationLike.vue?vue&type=script&lang=ts&"
export * from "./NotificationLike.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationLike.vue?vue&type=style&index=0&id=7d37f48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d37f48e",
  null
  
)

export default component.exports